
import { useQuery } from '@tanstack/react-query';
import useFetchWithMsal from "../../../hooks/useFetchWithMsal";
import { protectedResources } from "../../../authConfig";

export const useApprovers = () => {
    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    const fetchApprovers = async () => {
        try {
            const response = await execute(
                "GET",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/invoice-roles/approvers`
            );
            return response || [];
        } catch (error) {
            console.error('Error fetching approvers:', error);
            throw error;
        }
    };

    const { data: approvers = [], isLoading, error } = useQuery({
        queryKey: ['approvers'],
        queryFn: fetchApprovers,
        staleTime: 5 * 60 * 1000, 
        refetchOnWindowFocus: false
    });

    return {
        approvers,
        isLoading,
        error
    };
};